import React, { ReactNode } from "react"
import styles from "./Container.module.css"

const Container = ({ title, children }: { title: string; children: ReactNode }) => (
  <div className={styles.container}>
    <div className={styles.title}>{title}</div>
    {children}
  </div>
)

export default Container
